import React from "react";
import { useTranslation } from "react-i18next";
import { getI18nLocaleCode } from "../translations";
import { FixaWindow } from "@coworker/reusable/helpers/devices";

export type TFunction = (key: string, options?: object) => string;

function useModifiedTranslation() {
  const { i18n, t, ready } = useTranslation();
  const [lastIkeaLanguage, setLastIkeaLanguage] = React.useState("");

  /**
   * @type {import("react-i18next").TFunction<"translation">}
   */
  const modifiedT: TFunction = React.useCallback(
    (key, options) => {
      if ((window as FixaWindow).SHOW_TRANSLATION_KEYS) {
        return key;
      } else {
        return `${t(key, { ...options, returnDetails: false })}`;
      }
    },
    [t]
  );

  const changeLanguage = React.useCallback(
    (ikeaLangCode: string) => {
      setLastIkeaLanguage(ikeaLangCode);
      i18n.changeLanguage(getI18nLocaleCode(ikeaLangCode));
    },
    [i18n]
  );

  return React.useMemo(
    () => ({
      t: modifiedT,
      ready,
      i18n,
      changeLanguage,
      language: lastIkeaLanguage,
    }),
    [modifiedT, ready, i18n, changeLanguage, lastIkeaLanguage]
  );
}

export default useModifiedTranslation;
